import { render, staticRenderFns } from "./InvalidMandate.vue?vue&type=template&id=9c400a06&"
import script from "./InvalidMandate.vue?vue&type=script&lang=js&"
export * from "./InvalidMandate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports